// Audio Management System as purpose on NEWWEB-1424

import React from 'react';
import PageAuthorize from '../../../../security/PageAuthorize';
import RouteTitle from '../../../../presentation/RouteTitle';
import EditSectionCheckBox from '../../../../presentation/EditSectionCheckBox';
import EtelAPI from '../../../../api/EtelAPI';
import Alerts from '../../../../prototypes/Alerts';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { clearUserProfile } from '../../../../redux/actions/user';
import { clearBugsnagUser } from '../../../../redux/actions/bugsnag';
import * as WjGrid from 'wijmo/wijmo.react.grid';
import * as wjcCore from 'wijmo/wijmo';

// Wijmo Key
wjcCore.setLicenseKey(
  'stage.etelconnections.com|172.16.0.116|dev.etelconnections.com|172.16.2.189|stage.eteconnections.com|172.16.1.15|www.etelconnections.com|172.16.0.112|lv.etelconnections.com|etelconnections.com|www.dev.etelconnections.com|172.16.1.22,854482378799655#B032Sbj9ycu3Wa4NWZu96bjxWZ4VmLldWY4NnI0IyctRkIsIybjVGblRVLFJiOiEmTDJCLiUTN6kTO7gzNzIDO4QTN8IiOiQWSiwSfdtlOicGbmJCLiIjdyIDMyIiOiIXZ6JCLlNHbhZmOiI7ckJye0ICbuFkI1pjIEJCLi4TPBh7RwYjWClUQRFnby9UMrYUcIJEZa5EevlTSzJHepVjdqxEZsl7QxhUS4t6UyFEdPNGbClWMQJHc7Z4Kv2EcG5kQwVzdMd4dIpHMrwWcz8ESONUW4wUQ7tCSBhmMIhzcykGTMpmTlNXMvpXRrd5Qo3ES7NUcPtSM9YHMMBVRJ36MtxUTxx6cBdlM64mUIZDMOdGWYhGZC3EcHdkRSZjZFBFUZ5GZX9ET8tSTMNVe5R7dzhlaYFUc5YVOadUe6ZjZWVDULt4RNBndYJ7U4NTbwckRItUUsF7c42Wc94WVEh7Y4JzRQRmMnJ5QrAnaThWdygVSqdkZaBFRrlHVP3UcrYENzRTOVR5bRJXQ6xka8ZnTqdlcitEcxtWZzhFSqZXaZJkeG3yKFZkSCpkR6QnexYjb43SWH9UbChXRykGTkxETn5UVrlzavIlR0lFNuNkbtZEdIJDSiojITJCLikTO6czN6IUNiojIIJCLwEjM6gDM4gTO0IicfJye35XX3JSSwIjUiojIDJCLi86bpNnblRHeFBCI4VWZoNFelxmRg2Wbql6ViojIOJyes4nI5kkTRJiOiMkIsIibvl6cuVGd8VEIgIXZ7VWaWRncvBXZSBybtpWaXJiOi8kI1xSfis4N8gkI0IyQiwiIu3Waz9WZ4hXRgAydvJVa4xWdNBybtpWaXJiOi8kI1xSfiQjR6QkI0IyQiwiIu3Waz9WZ4hXRgACUBx4TgAybtpWaXJiOi8kI1xSfiMzQwIkI0IyQiwiIlJ7bDBybtpWaXJiOi8kI1xSfiUFO7EkI0IyQiwiIu3Waz9WZ4hXRgACdyFGaDxWYpNmbh9WaGBybtpWaXJiOi8kI1tlOiQmcQJCLiAzMwEDOwAyNxgDMzIDMyIiOiQncDJCLiIjMuEjL6EjLycTMs46bj9ycu3Wa4NWZu96bjxWZ4VmL6VGZuc7d7xSbvNmLz96bpR7Yl9mbvNGblRXZs46bj9ycu3Wa4NWZu96bjxWZ4VmL6xGLyETMuAjL6EjLycTMs46bj9ycu3Wa4NWZu96bjxWZ4VmL7d7dsUTMuEjL6EjLycTMs46bj9ycu3Wa4NWZu96bjVGdl9SZnFGdzxSO8EjLy8iNx8iM7EDLt36YuMnbvlGdjVmbu36YsVGdl9idlRGL6ETMuAjL6EjLtcYM'
);

const getGridStyle = () => ({
  'width': '100%',
  'height': '96%',
  'padding-top': '2px'
});

// Handles all items shown in ListContainer, all wijmo items are html items, because HTML rows are great and optimized for speed.
// onData methods generate some sort of html compatable display
class AudioManagementSystem extends React.Component {
  constructor() {
    super();

    this.state = {
      title: '',
      muuid: '',
      data: [],
      requestCallerSide: 1,
      requestSystemSide: 1
    };

    // Bindings so the application is not broken
    this.placeRequest = this.placeRequest.bind(this);
    this.prepareRequests = this.prepareRequests.bind(this);
    this.validateRequest = this.validateRequest.bind(this);
    this.setASide = this.setASide.bind(this);
    this.setBSide = this.setBSide.bind(this);
    this.loadGridData = this.loadGridData.bind(this);
    this.doLogOff = this.doLogOff.bind(this);
    this.updateMUUID = this.updateMUUID.bind(this);
    this.updateAllRows = this.updateAllRows.bind(this);
    this.setMediaEvents = this.setMediaEvents.bind(this);
    this.onHandleException = this.onHandleException.bind(this);

    // Renders
    this.onDataRenderAudioControl = this.onDataRenderAudioControl.bind(this);
    this.onDateRenderRequestType = this.onDateRenderRequestType.bind(this);
    this.onDateRenderRequestStatus = this.onDateRenderRequestStatus.bind(this);

    // Translation table for RequestType from the db, this will get changed to be a string
    this.RequestStatusNumeric = {
      0: 'pending',
      1: 'uploading',
      2: 'ready',
      3: 'failed',
      4: 'missing'
    }; // Enterprise.dbo.Type_AMS_Type

    // Wijmo grid fetch update
    this.updateWijmoGrid = this.updateWijmoGrid.bind(this);
    this._pendingGridUpdate = undefined;
    this._updateData = [];

    // Audio Player elements methods
    this.currentlyPlaying = undefined;
    this.playingAudio = this.playingAudio.bind(this);
    this.eventAudioPause = this.eventAudioPause.bind(this);
    this.eventAudioEnded = this.eventAudioEnded.bind(this);
    this.initializeMediaEvents = this.initializeMediaEvents.bind(this);
    this._mediaEvents = undefined;
    this._isMediaPlaying = false;

    // Cached HTML elements
    this.htmlCache = {
      // Type (Labels)
      '20 seconds': (
        '<div style="border: 1px solid #545C61; margin-left: 6px; background-color:#78838A; width: 80px; font-weight:600; line-height: 17px; text-align: center; color: white; border-radius: 3px; height: 18px; font-size: 9pt;"> 20 seconds </div>'
      ),
      'utterance': (
        '<div style="border: 1px solid #545C61; margin-left: 6px; background-color:#78838A; width: 80px; font-weight:600; line-height: 17px; text-align: center; color: white; border-radius: 3px; height: 18px; font-size: 9pt;"> Utterance </div>'
      ),
      'program': (
        '<div style="border: 1px solid #545C61; margin-left: 6px; background-color:#78838A; width: 80px; font-weight:600; line-height: 17px; text-align: center; color: white; border-radius: 3px; height: 18px; font-size: 9pt;"> Program </div>'
      ),
      'outbound': (
        '<div style="border: 1px solid #545C61; margin-left: 6px; background-color:#78838A; width: 80px; font-weight:600; line-height: 17px; text-align: center; color: white; border-radius: 3px; height: 18px; font-size: 9pt;"> Outbound </div>'
      ),
      'fullfile': (
        '<div style="border: 1px solid #545C61; margin-left: 6px; background-color:#78838A; width: 80px; font-weight:600; line-height: 17px; text-align: center; color: white; border-radius: 3px; height: 18px; font-size: 9pt;"> Full File </div>'
      ),

      // Modifiers
      'a-leg': (
        '<div style="border: 1px solid #517D73; margin-left: 2px; background-color: #659C8F; width: 80px; font-weight:600; line-height: 17px; text-align: center; color: white; border-radius: 3px; height: 18px; font-size: 9pt;"> System </div>'
      ),
      'b-leg': (
        '<div style="border: 1px solid #5B8D81; margin-left: 2px; background-color: #75A69A; width: 80px; font-weight:600; line-height: 17px; text-align: center; color: white; border-radius: 3px; height: 18px; font-size: 9pt;"> Caller </div>'
      ),

      // Status Types
      'pending': (
        '<div style="border: 1px solid #D39E00; background-color: #FFC107; width: 80px; line-height: 17px; text-align: center; color: black; border-radius: 3px; height: 18px; font-size: 9pt;"> Pending </div>'
      ),
      'failed': (
        '<div style="border: 1px solid #DD3445; background-color: #EB8C95; width: 80px; line-height: 17px; text-align: center; color: black; border-radius: 3px; height: 18px; font-size: 9pt;"> Failed </div>'
      ),
      'uploading': (
        '<div style="border: 1px solid #1AB6CF; background-color: #7ADFEE; width: 80px; line-height: 17px; text-align: center; color: black; border-radius: 3px; height: 18px; font-size: 9pt;"> Uploading </div>'
      ),
      'ready': (
        '<div style="border: 1px solid #34CE58; background-color: #72DD8B; width: 80px; line-height: 17px; text-align: center; color: black; border-radius: 3px; height: 18px; font-size: 9pt;"> Ready </div>'
      ),
      'missing': (
        '<div style="border: 1px solid #9A9D9D; background-color: #C1C3C3; width: 80px; line-height: 17px; text-align: center; color: black; border-radius: 3px; height: 18px; font-size: 9pt;"> Missing </div>'
      )
    };

    // Wijmo references
    this.wijmopanel = undefined;

    // Component props
    this._ismounted = false;
  }

  // Sets Object properties to verify that no audio is playing allowing a status
  // update to happen if pending
  // @arg: elem -> The document.Object ref
  eventAudioPause(elem) {
    // Checks that the same element was passed
    if (elem === this.currentlyPlaying) {
      this._isMediaPlaying = false; // Will only set to false if the same element raised the Event
    }
  }

  // Sets Object properties to allow pending status updates to occur
  // @arg: elem -> The document.Object ref
  eventAudioEnded(elem) {
    this._isMediaPlaying = false; // Since only one audio elem can be playing only one (the current playing) can stop
  }

  // Loads the data
  componentDidMount() {
    this._ismounted = true;
    this.loadGridData();
  }

  // Clears any intervals set (if not cleared yet)
  componentWillUnmount() {
    this._ismounted = false;

    // Clears any set intervals
    clearInterval(this._pendingGridUpdate);
    clearInterval(this._mediaEvents);
  }

  // Handles exceptions
  onHandleException(e) {
    const title = 'Audio Management';
    const bugsnag = this.props.bugsnag;
    const { dispatch } = this.props;
    const alerts = new Alerts(bugsnag, dispatch);
    const status = e.status === undefined ? 0 : e.status;
    if (status === 410) {
      alerts.INFO(title, 'Your session has expired.', 5000);
      this.doLogOff();
    } else if (status === 500) {
      alerts.INFO(title, e.statusText, 5000);
      this.doLogOff();
      // This only needs to warn the user
    } else if (status === 400) {
      alerts.WARNING(title, 'Request timed out.', 5000);
    } else {
      alerts.CRITICAL(title, e);
    }
  }

  // Returns user back to the login page if creds fail
  doLogOff() {
    const { dispatch } = this.props;
    const auth = this.props.auth;
    const history = this.props.history;
    auth.logout();
    dispatch(clearBugsnagUser());
    dispatch(clearUserProfile());
    history.push('/login');
  }


  // Maps playing to events. This allows other playing ID's to be stopped + pending updates to occur
  setMediaEvents() {
    if (this._ismounted === true && this.wijmopanel) {
      // Selects all items with "audio-player" in the ID field
      let elems = document.querySelectorAll('[id*="audio-player"]');

      // Maps elements currently present on the grid
      if (elems.length !== 0) {
        for (let x = 0; x < elems.length; x++) {
          let elem = elems[x];

          // Id based mapping (passing this ref)
          elem.onplay = () => this.playingAudio(elem);
          elem.onpause = () => this.eventAudioPause(elem);
          elem.onended = () => this.eventAudioEnded(elem);
        }

        // Clears the mapping once it's set
        clearInterval(this._mediaEvents);
      }
    }
  }

  // Utility to set _mediaEvent interval in a method, this will trigger after
  // a state update
  initializeMediaEvents() {
    this._mediaEvents = setInterval(this.setMediaEvents, 200);
  }

  // Let's only one audio element to play at a time
  // @arg: elem -> The DOM element which fired the event
  playingAudio(elem) {
    if (this.currentlyPlaying) {
      if (this.currentlyPlaying !== elem) {
        this.currentlyPlaying.pause();
        this.currentlyPlaying = elem;
        this._isMediaPlaying = true;
      }
    } else {
      this.currentlyPlaying = elem;
      this._isMediaPlaying = true;
    }
  }

  // Injects new data (none state) into the wijmo grid
  updateWijmoGrid() {
    if (this._ismounted === true && this._isMediaPlaying !== true) {
      if (this.wijmopanel) {
        let api = new EtelAPI('ams');
        let retrigger = false;

        api.get({}).then((result) => {
          let changes = {};

          // Getting possible changes
          for (let x = 0; x < result.length; x++) {
            const row = result[x];
            const status = row.RequestStatus;
            let name = row['M_UUID'] + '-' + row['RequestMod'];

            changes[name] = row.RequestStatus;

            // If status are still pending
            if (status < 2) {
              retrigger = true;
            }
          }

          // Comparing current grid values vs new ones, any change will trigger a state change
          let updateState = false;
          const data = this.state.date;
          for (let x = 0; x < data; x++) {
            const row = data[x];
            const status = row.RequestStatus;
            let name = row['M_UUID'] + '-' + row['RequestMod'];

            if (changes[name] && changes[name] !== status) {
              updateState = true;
              break; // We can exit the loop as an element status has changed
            }
          }

          // Relaunch on pending changes
          if (retrigger === true) {
            this._pendingGridUpdate = setInterval(this.updateWijmoGrid, 200);
          }

          // Updating the state
          if (updateState === true) {
            this.updateAllRows(result, false);
          }
        }).catch((error) => {
          this.onHandleException(error);
        });

        clearInterval(this._pendingGridUpdate);
      }
    }
  }

  // Prepares the request and sends to proc to be processed for MULTIPLE MUUIDs 
  prepareRequests() {
    let muuids = this.state.muuid;
    let muuid_array = muuids.split(',');

    // Iterating through M_UUIDs
    for (var index = 0; index < muuid_array.length; index++) {
      let muuid = muuid_array[index].replace(/\s+/g, ' ').trim()

      // Placing the reque
      this.placeRequest(muuid)
    }
  }


  // Validates the request and sends to proc to be processed
  // -- uses component value to limit state rendering
  // @arg muuid[str] => M_UUID to be fetched
  placeRequest(muuid) {
    // Validates that's a valid muud
    if (this.validateRequest(muuid) === true) {
      const bugsnag = this.props.bugsnag;
      const { dispatch } = this.props;
      const alerts = new Alerts(bugsnag, dispatch);
      let api = new EtelAPI('ams');
      api.insert({
        M_UUID: muuid,
        CallerSide: this.state.requestCallerSide,
        SystemSide: this.state.requestSystemSide
      }).then((result) => {
        const data = result.data;
        // Checks that an error message was not returned
        if (data[0] && data[0].error_msg) {
          alerts.CRITICAL('Audio Management', data[0].error_msg);
        } else {
          this.loadGridData(); // We need to rebind requests to update
        }
      }).catch((error) => {
        this.onHandleException(error);
      });
    } else {
      const bugsnag = this.props.bugsnag;
      const { dispatch } = this.props;
      const alerts = new Alerts(bugsnag, dispatch);
      alerts.WARNING('Audio Management', 'Invalid MUUID', 2000);
    }
  }

  // Validates MUUIDS (UUID4s)
  // @arg: muuid[str] -> The uuid4 with '-' or not, to look up
  // @r: boolean, true if valid, else false
  validateRequest(muuid) {
    if (muuid && muuid.length >= 32) {
      let m_id = muuid.replace(/-/g, '');

      // Size check, fails out
      if (m_id.length !== 32) {
        return false;
      }

      // Position check
      for (var index = 0; index < m_id.length; index++) {
        const character = m_id.charAt(index);

        // Validates 12 is 4
        if (index === 12) {
          if (character !== '4') {
            return false;
          }

          // Validates postion 16 is 8,9,a,b
        } else if (index === 16) {
          if (character === '8' || character === '9' || character === 'a' || character === 'b') {
            continue;
          } else {
            return false;
          }

          // Validates value is hex (0-9, a-f), if a none hex value the same value is returned
        } else {
          const int_eq = parseInt(character, 16); // NAN on none radix 16

          // Fails if the origin value is not equal to the string version
          if (int_eq.toString(16) !== character) {
            return false;
          }
        }
      }
      return true;
    }
    return false;
  }

  // Updates all rows at once
  updateAllRows(data, clear_muuid = false) {
    // On data, result is data array
    let new_data = [];

    // Iterating over what came back
    for (let i = 0; i < data.length; i++) {
      let push_value = {};
      const row = data[i];
      const result_requestType = row.RequestType;
      const result_requestMod = parseInt(row.RequestMod, 10);

      push_value['RequestType'] = result_requestType;
      push_value['RequestDate'] = row.RequestDate;
      push_value['RecordingDate'] = row.RecordingDate;
      push_value['RequestMUUID'] = row.M_UUID;
      push_value['RequestPDNIS'] = row.PDNIS;

      if (result_requestMod === 0) {
        push_value['drawRequestType'] = this.onDateRenderRequestType(result_requestType, null);
      } else if (result_requestMod === 1) {
        push_value['drawRequestType'] = this.onDateRenderRequestType(result_requestType, 'a-leg');
      } else {
        push_value['drawRequestType'] = this.onDateRenderRequestType(result_requestType, 'b-leg');
      }

      push_value['drawRequestStatus'] = this.onDateRenderRequestStatus(this.RequestStatusNumeric[row.RequestStatus]);
      push_value['drawControlCell'] = this.onDataRenderAudioControl(row.RequestMod, row.M_UUID, result_requestType);

      new_data.push(push_value);
    }

    // Updating the state
    if (clear_muuid === true) {
      // Clears MUUID on success
      this.setState({
        muuid: '',
        data: new_data
      }, this.initializeMediaEvents);
    } else {
      this.setState({
        data: new_data
      }, this.initializeMediaEvents);
    }
  }

  // Loads user specific request data
  loadGridData() {
    let api = new EtelAPI('ams');
    api.get({}).then((result) => {

      // Will execute none state grid update if the data is still to be updated
      let executeInterval = false;

      // On data, result is data array
      let new_data = [];
      for (let i = 0; i < result.length; i++) {
        let push_value = {};
        const row = result[i];
        const result_requestType = row.RequestType;
        const result_requestMod = parseInt(row.RequestMod, 10);

        // Checks to see if any row is pending
        if (row.RequestStatus < 2) {
          executeInterval = true;
        }

        push_value['RequestType'] = result_requestType;
        push_value['RequestDate'] = row.RequestDate;
        push_value['RecordingDate'] = row.RecordingDate;
        push_value['RequestMUUID'] = row.M_UUID;
        push_value['RequestPDNIS'] = row.PDNIS;

        if (result_requestMod === 0) {
          push_value['drawRequestType'] = this.onDateRenderRequestType(result_requestType, null);
        } else if (result_requestMod === 1) {
          push_value['drawRequestType'] = this.onDateRenderRequestType(result_requestType, 'a-leg');
        } else {
          push_value['drawRequestType'] = this.onDateRenderRequestType(result_requestType, 'b-leg');
        }

        push_value['drawRequestStatus'] = this.onDateRenderRequestStatus(this.RequestStatusNumeric[row.RequestStatus]);
        push_value['drawControlCell'] = this.onDataRenderAudioControl(row.RequestMod, row.M_UUID, result_requestType);

        new_data.push(push_value);
      }

      // Sets update interval on new data
      if (executeInterval === true) {
        this._pendingGridUpdate = setInterval(this.updateWijmoGrid, 200);
      }

      this.setState({
        muuid: '',
        data: new_data
      }, this.initializeMediaEvents);
    }).catch((error) => {
      this.onHandleException(error);
    });
  }

  // Updates the components muuid (this.) not the state, the child
  // component keeps the state, so no need to update the parent
  // @arg: e[event] -> The synthetic event fired by the component
  updateMUUID(e) {
    if (this._ismounted === true) {
      this.setState({
        muuid: e.target.value.toLowerCase()
      });
    }
  }

  // Toggles the A side (system) for the recording
  setASide() {
    if (this._ismounted === true) {
      this.setState({
        requestSystemSide: (this.state.requestSystemSide - 1) * -1
      });
    }
  }

  // Toggles the B side (caller) for the recording
  setBSide() {
    if (this._ismounted === true) {
      this.setState({
        requestCallerSide: (this.state.requestCallerSide - 1) * -1
      });
    }
  }

  // Renders the audio controls with source location
  onDataRenderAudioControl(mod, muuid, RequestType) {
    let RequestTypeString = '';

    if (RequestType === '20 seconds') {
      RequestTypeString = '20_seconds/' + mod + '/';
    }

    return '<audio id="' + muuid + '-' + mod + '-audio-player" controls="controls" src=' +
      'https://etelvoicefiledata.s3.amazonaws.com/' + RequestTypeString + muuid + '.wav type="audio/wav">';
  }

  // Renders the label for the [Type] Column (drawRequestType)
  // @arg: type[str] -> The type of file requested
  // @arg: modifier[str] -> The mods on that file, a-leg, b-leg, or both
  onDateRenderRequestType(type, modifier) {
    let htmlstring = this.htmlCache[type]; // The type

    // Adds a flex div for next to next view
    if (modifier) {
      htmlstring = '<div style="display:flex">' + htmlstring + this.htmlCache[modifier] + '</div>';
    }
    return htmlstring;
  }

  // Returns the html label from the cache for the status
  // @arg: status[str] -> The current request status
  onDateRenderRequestStatus(status) {
    return this.htmlCache[status];
  }

  // Returns the wijmo grid renders, rows are independent (none React tides, document level)
  render() {
    return (
      // Adds 3 standard groupds + AudioManagementSystem group for single access
      <PageAuthorize groups={['Administrators', 'Operations', 'Management', 'AudioManagementSystem']} key={'ams-has-access-key'}>

        <div className="ams-container">
          <RouteTitle title='Audio Management System' />
          <div className="ams-page-title"> Audio Management System </div>
          <div className="ams-filter-container">
            {/* MUUID INPUT */}
            <span className="ams-filter-container-input">
              <label>MUUID(s)</label>
              <input type="text" value={this.state.muuid} onChange={this.updateMUUID} />
            </span>
            {/* System-side btn */}
            <span className="ams-filter-container-systemside">
              <EditSectionCheckBox id='checkbox-a-leg' checked={this.state.requestSystemSide === 1 ? true : false} label={'System-Side'} onChanged={this.setASide} />
            </span>
            {/* Caller-side btn */}
            <span className="ams-filter-container-callerside">
              <EditSectionCheckBox id='checkbox-b-leg' checked={this.state.requestCallerSide === 1 ? true : false} label={'Caller-Side'} onChanged={this.setBSide} />
            </span>
            {/* Full-file btn */}
            <span className="ams-filter-container-fullfile">
              <EditSectionCheckBox id='checkbox-full-file' label={'Full-File'} />
            </span>
            {/* Request btn */}
            <span className="ams-filter-container-requestbtn">
              <button className="ams-request-button" onClick={this.prepareRequests}>Request</button>
            </span>
          </div>



          <div className="ams-page-body">
            <WjGrid.FlexGrid
              ref={(panel) => this.wijmopanel = panel}
              autoGenerateColumns={false}
              allowDragging={0}
              itemsSource={this.state.data}
              selectionMode="CellRange"
              autoClipboard={true}
              allowAddNew={false}
              allowDelete={false}
              style={getGridStyle()}
              allowSorting={true}>

              <WjGrid.FlexGridColumn header="Requested Date" binding="RequestDate" width={145} isReadOnly={true} />
              <WjGrid.FlexGridColumn header="Type" binding="drawRequestType" width={180} isReadOnly={true} isContentHtml={true} sortMemberPath="RequestType" />
              <WjGrid.FlexGridColumn header="Status" binding="drawRequestStatus" width={90} isReadOnly={true} isContentHtml={true} sortMemberPath="RequestStatus" />
              <WjGrid.FlexGridColumn header="MUUID" binding="RequestMUUID" width={280} isReadOnly={true} />
              <WjGrid.FlexGridColumn header="PDNIS" binding="RequestPDNIS" width={100} isReadOnly={true} />
              <WjGrid.FlexGridColumn header="Recording Date" binding="RecordingDate" width={145} isReadOnly={true} />
              <WjGrid.FlexGridColumn header="Controls" binding="drawControlCell" width="1*" isReadOnly={true} isContentHtml={true} />

            </WjGrid.FlexGrid>
          </div>
        </div>
      </PageAuthorize >
    );
  }
}

// Exports
export default withRouter(
  connect(
    (store) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )(AudioManagementSystem)
);


// WEBPACK FOOTER //
// ./src/content/technical/audiomgmt/components/AMS.js